import PropTypes from 'prop-types';

import {planPropTypes} from '../../utils/propTypes';

import Plan from '../Plan';

function PlanSelection(props) {
  return (
    <div className="row justify-content-center">
      {props.plans.map((plan, key) => (
        <Plan
          key={key}
          plan={plan}
          maxDefaultFeatures={props.maxDefaultFeatures}
          onPlanSelection={props.onPlanSelection}
          currentPlan={props.currentPlan}
        />
      ))}
    </div>
  );
}

PlanSelection.defaultProps = {
  maxDefaultFeatures: 25
};

PlanSelection.propTypes = {
  plans: PropTypes.arrayOf(planPropTypes()).isRequired,
  onPlanSelection: PropTypes.func.isRequired,
  // Optional props
  currentPlan: PropTypes.shape({
    externalId: PropTypes.string.isRequired
  }),
  maxDefaultFeatures: PropTypes.number
};

export default PlanSelection;
